import { Component, ViewEncapsulation, HostBinding, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { MatIconModule } from '@angular/material/icon';
import { NgIf } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

import { SafeUrlPipe } from '../../pipes/safeurl.pipe';

interface LinkData {
	linkData(params: ICellRendererParams<unknown, unknown>): { url: string; type: string; icon: string };
}

@Component({
	selector: 'copo-icon-go-to-document-cell',
	templateUrl: './icon-open-document-cell.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [NgIf, MatIconModule, SafeUrlPipe, TranslatePipe]
})
export class IconOpenDocumentCellComponent implements ICellRendererAngularComp {
	@HostBinding('class.passthrough') readonly passthrough = true;

	linkData?: { url: string; type: string; icon: string; titleTranslation?: string };

	constructor(readonly changeDetectorRef: ChangeDetectorRef) {}

	agInit(params: ICellRendererParams<unknown, unknown>) {
		if (!params.colDef) {
			return;
		}
		this.linkData = (<LinkData> params.colDef.cellRendererParams).linkData(params);
		this.changeDetectorRef.markForCheck();
	}

	refresh(params: ICellRendererParams<unknown, unknown>) {
		if (!params.colDef) {
			return false;
		}
		this.linkData = (<LinkData> params.colDef.cellRendererParams).linkData(params);
		this.changeDetectorRef.markForCheck();
		return true;
	}
}
